export default __webpack_public_path__ + "img/piQGxKxR.37c47078.svg";